import { RefineToolTabs } from "./RefineToolTabs";

type RefineHeaderProps = {
  activeTool: string;
  onToolChange: (tool: string) => void;
};

export function RefineHeader({ activeTool, onToolChange }: RefineHeaderProps) {
  return (
    <div className="absolute left-0 right-0 top-0 z-10 flex flex-col">
      <div className="flex w-full items-center justify-between bg-white p-2 shadow-md">
        <div className="flex-1">
          <h2 className="text-lg font-medium text-gray-800">Edit Artwork</h2>
        </div>
        <div className="flex flex-1 justify-end"></div>
      </div>

      <div className="mt-2 w-full px-4">
        <RefineToolTabs activeTool={activeTool} onToolChange={onToolChange} />
      </div>
    </div>
  );
}
